// mutation-types.js
export const SET_NOTIFICATION = 'SET_NOTIFICATION'
export const SET_ERROR_NOTIFICATION = 'SET_ERROR_NOTIFICATION'
export const REMOVE_NOTIFICATION_MUTATION = 'REMOVE_NOTIFICATION_MUTATION'
